var map = {
	"./caltech.png": 513,
	"./caltech@2x.png": 514,
	"./campridge.png": 515,
	"./campridge@2x.png": 516,
	"./harvard.png": 517,
	"./harvard@2x.png": 518,
	"./mit.png": 519,
	"./mit@2x.png": 520,
	"./oxford.png": 521,
	"./oxford@2x.png": 522,
	"./stanford.png": 523,
	"./stanford@2x.png": 524
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 118;